import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { AUTH0_IDP_IDENTIFIER, AUTH0_IDP_IDENTIFIER_KEY } from './zillowSignIn/constants';

export const appendAuth0IdpIdentifier = async (signInOptions: Record<string, string>) => {
    try {
        // eslint-disable-next-line import/dynamic-import-chunkname
        const { getAuth0QueryParams } = await import('@zillow/universal-analytics');
        const auth0QueryParams = await getAuth0QueryParams();
        signInOptions[auth0QueryParams.key] = auth0QueryParams.value;
        signInOptions[AUTH0_IDP_IDENTIFIER_KEY] = AUTH0_IDP_IDENTIFIER;
    } catch (error) {
        // This is a known error that occurs occasionally on slow connections
        if (
            !(error as Error).message.includes('window.ua was never initialized. The getAuth0QueryParams call failed.')
        ) {
            await DatadogRUMService.Client.getInstance().addAction(DatadogRUMService.CustomAction.CLICKSTREAM_EVENT, {
                error: (error as Error).message,
            });
        }
    }
};
